import React from "react"
import RequestForm from "../../components/request-form"
import { BLOCKS } from "@contentful/rich-text-types"
import { renderRichText } from "gatsby-source-contentful/rich-text"

export default function Form({ FormData, hubspotData, color }) {
	const { richText, tagline, title, desc, formGraphic, synopsis, eventDatetime } = FormData
	const slug = typeof window !== "undefined" ? window.location.pathname : ""
	const options = {
		renderNode: {
			[BLOCKS.HEADING_5]: (node, children) => {
				return (
					<h5 className="text-ProjectBlack Saira-Bold leading-lineheight140 max-w-[493px] mt-4 text-left text-base md:text-[21px] font-normal tracking-wide">
						{children}
					</h5>
				)
			},
			[BLOCKS.UL_LIST]: (node, children) => {
				return (
					<ul className="list-disc ml-7">
						<li className="text-ProjectBlack font-workSans font-normal leading-6 mt-4 text-left text-[19px]">
							{children}
						</li>
					</ul>
				)
			},
			[BLOCKS.PARAGRAPH]: (node, children) => {
				if (node.content[0].value === "") {
					return <br />
				} else {
					return <p className="text-[18px] font-normal font-workSans leading-6">{children}</p>
				}
			},
		},
	}
	return (
		<>
			<div className="w-screen bg-black mx-auto relative px-5 md:px-10 xl1:px-40 ">
				<div className="flex flex-col items-start justify-between max-w-screen-xl  py-10 mx-auto md:flex-col">
					{/* Section One (Text) */}
					<div className="flex md:flex-row flex-col md:gap-[50px]">
						<div className={`${slug === "/talk-to-sales" || slug === "/get-a-demo" ? "md:w-[55%] lg:w-[50%]" : "md:w-[60%]"} w-full md:pr-[60px]`}>
							<h4 className="text-sm my-0 md:text-base font-semibold tracking-widest uppercase text-ProjectBlue Figtree leading-4 "
								data-sal="slide-up"
								data-sal-duration="1200"
								data-sal-delay="0"
								data-sal-easing="ease-animationSection"
							>
								{tagline}
							</h4>
							<h1 className="text-[28px] py-[20px] md:text-[44px] tracking-atswide uppercase text-ProjectBlack Saira-Bold not-italic leading-lineheight120 font-bold md:max-w-[650px]"
								data-sal="slide-up"
								data-sal-duration="1200"
								data-sal-delay="0"
								data-sal-easing="ease-animationSection"
							>
								{title}
							</h1>
							<p className="text-ProjectBlack font-workSans font-normal leading-6 max-w-[500px] text-left text-base md:text-[19px]"
								data-sal="slide-up"
								data-sal-duration="1200"
								data-sal-delay="0"
								data-sal-easing="ease-animationSection"
							>
								{desc}
							</p>
							{eventDatetime && <p className="text-ProjectBlack pb-[30px] font-workSans font-bold leading-6 max-w-[500px] text-left text-base md:text-[18px]"
								data-sal="slide-up"
								data-sal-duration="1200"
								data-sal-delay="0"
								data-sal-easing="ease-animationSection"
							>
								{eventDatetime}
							</p>}

							{synopsis && <p className="text-ProjectBlack font-workSans font-normal leading-6 max-w-[100%] text-left text-base md:text-[19px]"
								data-sal="slide-up"
								data-sal-duration="1200"
								data-sal-delay="0"
								data-sal-easing="ease-animationSection"
							>
								{synopsis}
							</p>}

							{formGraphic && (
								<div className="w-full md:w-[100%] lg:w-[100%] my-10"
									data-sal="slide-up"
									data-sal-duration="1200"
									data-sal-delay="0"
									data-sal-easing="ease-animationSection"
								>
									<img
										src={`${formGraphic?.file?.url}`}
										className="md:max-w-[500px] md:w-full md:h-full object-fill object-center overflow-hidden"
										alt=""
									/>
								</div>
							)}
						</div>
						<div className={`mb-[35px] md:m-0 ${slug === "/talk-to-sales" || slug === "/get-a-demo" ? " md:max-w-[45%] lg:max-w-[50%]" : "md:w-[40%]"}  w-full md:mt-0`}>
							<RequestForm hubspotData={hubspotData} />
						</div>
					</div>
					{/* Setion Two (Form) */}
					{richText && <div className={`max-w[100%] md:max-w-[50%] render-sales-text ${color} mb-[100px]`}
						data-sal="slide-up"
						data-sal-duration="1200"
						data-sal-delay="0"
						data-sal-easing="ease-animationSection"
					>
						{renderRichText(richText, options)}
					</div>}
				</div>
			</div>
		</>
	)
}


